import { render, staticRenderFns } from "./userThreparty.vue?vue&type=template&id=0b9308bc"
import script from "./userThreparty.vue?vue&type=script&lang=js"
export * from "./userThreparty.vue?vue&type=script&lang=js"
import style0 from "./userThreparty.vue?vue&type=style&index=0&id=0b9308bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports